module.exports = ".save-button {\r\n  color: #9b9b9b;\r\n}\r\n\r\n  .save-button :hover {\r\n    color: #666666;\r\n  }\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/fsapplication/admin-app/admin-app.component.css
// module id = ./src/app/fsapplication/admin-app/admin-app.component.css
// module chunks = main